"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function memo(func) {
  var cache = {};

  var memoFunc = function memoFunc(key) {
    if (typeof key === 'string' && cache.hasOwnProperty(key)) {
      return cache[key];
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var result = func.apply(void 0, [key].concat(args));

    if (typeof key === 'string') {
      cache[key] = result;
    }

    return result;
  };

  return memoFunc;
}

var _default = memo;
exports.default = _default;
//# sourceMappingURL=memo.js.map